import { Box, Group, Stack } from "@mantine/core";

import EntitiesDropTarget from "../EntitiesDropTarget/EntitiesDropTarget";
import ConditionsTree from "../ConditionsTree/ConditionsTree";
import DataFieldsDropTarget from "../DataFieldsDropTarget/DataFieldsDropTarget";
import GroupBy from "../GroupBy/GroupBy";
import OrderBy from "../OrderBy/OrderBy";
import LimitInput from "../LimitInput/LimitInput";
import QueryName from "../QueryName/QueryName";

/**
 * One full query "level" — the same component renders the top-level
 * query and each recursive subquery, differing only in visual flags.
 *
 * enableJoins renders the extra joinGroups ConditionsTree (subqueries only).
 */
export default function QuerySection({
  ruleId,
  query,
  allEntitiesData,
  canEdit = true,
  isSubquery = false,
  enableJoins = false,
  headerRightSlot,
}) {
  if (!query) return null;
  const queryId = query.id;

  return (
    <Stack gap="sm">
      <Group justify="space-between" wrap="nowrap" align="center">
        <QueryName
          ruleId={ruleId}
          queryId={queryId}
          initialValue={query.alias}
          canEdit={canEdit}
        />
        {headerRightSlot}
      </Group>

      <EntitiesDropTarget
        ruleId={ruleId}
        queryId={queryId}
        allEntitiesData={allEntitiesData}
        canEdit={canEdit}
        isSubquery={isSubquery}
      />

      <ConditionsTree
        ruleId={ruleId}
        queryId={queryId}
        forJoin={false}
        conditions={query.conditionGroups}
        canEdit={canEdit}
        isSubquery={isSubquery}
      />

      {enableJoins && (
        <ConditionsTree
          ruleId={ruleId}
          queryId={queryId}
          forJoin={true}
          conditions={query.joinGroups}
          canEdit={canEdit}
          isSubquery={isSubquery}
        />
      )}
      <Box
        style={{
          contain: "inline-size",
          display: "grid",
          gridTemplateColumns: isSubquery
            ? "repeat(2, minmax(0, 1fr))"
            : "repeat(3, minmax(0, 1fr))",
          gap: "var(--mantine-spacing-md)",
          alignItems: "start",
        }}
      >
        {!isSubquery && (
          <DataFieldsDropTarget
            ruleId={ruleId}
            queryId={queryId}
            dataFields={query.dataFields}
            canEdit={canEdit}
          />
        )}
        <GroupBy
          ruleId={ruleId}
          queryId={queryId}
          groups={query.groups}
          canEdit={canEdit}
          isSubquery={isSubquery}
        />
        <OrderBy
          ruleId={ruleId}
          queryId={queryId}
          orderByData={query.orderBy}
          canEdit={canEdit}
        />
      </Box>

      <LimitInput
        ruleId={ruleId}
        queryId={queryId}
        currentLimit={query.limit?.limit}
        canEdit={canEdit}
        isSubquery={isSubquery}
      />
    </Stack>
  );
}
